import Tag from 'src/modules/shared/components/atoms/tag';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';
import {
  type ComponentAppearance,
  type ComponentSize,
  type ComponentVariant,
} from 'src/modules/shared/types/component.type';
import { classes } from 'src/modules/shared/utils/styles.util';
import { type ReactNode } from 'react';

interface StatusPillProps {
  label: ReactNode;
  variant?: ComponentVariant;
  appearance?: ComponentAppearance;
  size?: ComponentSize;
  tooltip?: string;
  className?: string;
  icon?: ReactNode;
}

export const StatusPill: React.FC<StatusPillProps> = ({
  label,
  variant = 'primary',
  appearance = 'soft',
  size = 'sm',
  tooltip,
  className,
  icon,
}) => {
  const content = (
    <Tag
      content={label}
      size={size}
      variant={variant}
      appearance={appearance}
      icon={icon}
      className={classes('px-3 py-1', className)}
      textClassName={
        size === 'xs' || size === '2xs' ? 'text-[11px]' : 'text-xs'
      }
    />
  );

  if (!tooltip) {
    return content;
  }

  return (
    <Tooltip size="sm" content={tooltip} placement="top">
      {content}
    </Tooltip>
  );
};
